export default "__VITE_ASSET__36111e17__"